import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let wrkServiceConfigs = {
  /**
   * wrkServiceConfig List
   */
  async wrkServiceConfigList (context, whereFilter = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "wrk_service_config_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkServiceConfigList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfig View
   */
  async wrkServiceConfigView (context, wrkServiceConfigId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("service_id", wrkServiceConfigId)

      return await request.curl(context, "wrk_service_config_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkServiceConfigView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfig Add
   */
  async wrkServiceConfigAdd (context, wrkServiceConfigObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkServiceConfigObj) {
        postData.append(key, wrkServiceConfigObj[key])
      }

      return await request.curl(context, "wrk_service_config_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkServiceConfigAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfig Edit
   */
  async wrkServiceConfigEdit (context, wrkServiceConfigObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkServiceConfigObj) {
        postData.append(key, wrkServiceConfigObj[key])
      }

      return await request.curl(context, "wrk_service_config_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkServiceConfigEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfig Delete
   */
  async wrkServiceConfigDelete (context, wrkServiceConfigId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("service_id", wrkServiceConfigId)

      return await request.curl(context, "wrk_service_config_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at wrkServiceConfigDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfig FilterList
   */
  async wrkServiceConfigFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "wrk_service_config_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrk_service_config_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkServiceConfigDistinctServiceType
   */
  async wrkServiceConfigDistinctServiceType (context, wrkServiceConfigObj = {}) {
    try {
      let postData = new FormData()
      for (let key in wrkServiceConfigObj) {
        postData.append(key, wrkServiceConfigObj[key])
      }

      return await request.curl(context, "wrk_service_config_distinct_service_type", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkServiceConfigDistinctServiceType() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  wrkServiceConfigs
}
